import Home from "./Home"
import FreeTrial from "./Freetrial"
import Settings from "./Settings"
import AIChat from "./AIChat"
import Calendar from "./calendar"
import Dashboard from "./Dashboard/Dashboard"
import LocationIntegration from "./Settings/components/LocationIntegration"
import YourAIAgents from "./YourAIAgents/YourAIAgents"
import Chat from "./Chat/index"

const useRoutes = () => {
  // const [user] = useUserInfo();
  return [
    {
      type: "collapse",
      key: "not_found",
      route: "/404",
      component: <></>,
    },
    {
      type: "collapse",
      key: "home",
      route: "/home",
      component: <Home />,
    },
    {
      type: "collapse",
      key: "home",
      route: "/dashboard",
      component: <Dashboard />,
    },
    {
      type: "collapse",
      key: "freetrial",
      route: "/freetrial",
      component: <FreeTrial />,
    },
    {
      type: "collapse",
      key: "settings",
      route: "/settings",
      component: <Settings />,
    },
    {
      type: "collapse",
      key: "ai-agents",
      route: "/ai-agents",
      component: <YourAIAgents />,
    },
    {
      type: "collapse",
      key: "chat",
      route: "chat/*",
      component: <Chat />,
    },
    {
      type: "collapse",
      key: "aichat",
      route: "/aichat",
      component: <AIChat />,
    },
    {
      type: "collapse",
      key: "calendar",
      route: "/calendar",
      component: <Calendar />,
    },
    {
      type: "collapse",
      key: "location_integration",
      route: "/location_integration",
      component: <LocationIntegration />,
    },
    // Account Setup (/add-account-setup) is intentionally not registered here
    // — it's a standalone, full-page flow (no sidebar) and is mounted
    // directly in pages/index.js, outside the AppShell-wrapped route block.
    // {
    //   type: "collapse",
    //   key: "freetrial",
    //   route: "/free-trial",
    //   component: <FreeTrail />,
    // },
    // {
    //   type: "collapse",
    //   key: "authentication",
    //   route: "/auth/*",
    //   component: <Authentication />,
    //   guard: {
    //     valid: !user.email,
    //     redirect: `/dashboard`,
    //   },
    // },
    // {
    //   type: 'collapse',
    //   key: 'integration',
    //   route: '/integrations/*',
    //   component: <Integration />,
    // },
    // {
    //   type: "collapse",
    //   key: "superadmin",
    //   route: "/*",
    //   component: <SuperAdmin />,
    //   guard: {
    //     valid: user.email && user.roles.includes(Roles.AGENCY),
    //     redirect: "/auth/sign-in",
    //   },
    // },
  ];
};

export default useRoutes;
